<template>
  <div id="main-container">
    <div class="title"> {{ $t('seatEditor.title', {sectorName: this.currentSectorName}) }} </div>
    <div class="actions">
      <div class="append-menu">
        <v-btn
          id="seat-menu-activator"
          color="primary"
          width="200px"
        >
          {{ $t('seatEditor.newSeat.title') }}
        </v-btn>

        <v-menu activator="#seat-menu-activator">
          <v-list>
            <v-list-item
              v-for="(item, index) in appendSeatItems"
              :key="index"
              :value="index"
              @click="item.action"
              :append-icon="item.img"
            >
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="upload-image">
        <v-btn class="upload-btn" color="#666666" @click="uploadImage"> {{ $t('seatEditor.uploadImage') }} </v-btn>
        <input
          ref="uploader"
          class="hidden-uploader"
          type="file"
          accept="image/*"
          @change="onFileChanged"
        >
      </div>
      <v-btn class="info-btn" @click="showInfoModal"> {{this.$t('sectorEditor.actionInfoModal.title')}} </v-btn>
      <!-- <div class="save-seats">
        <v-btn class="save-btn" color="primary" @click="saveSeats"> {{ $t('seatEditor.saveSeats') }}</v-btn>
      </div> -->
    </div>
    <v-card class="editor-section">
      <div ref="container" class="konva-container" :class="canDrawing ? 'currently-drawing' : ''"></div>
      <div class="btn-section">
        <v-btn icon="mdi-minus" @click="zoomWithBtn()"/>
        <v-btn icon="mdi-plus" @click="zoomWithBtn(true)"/>
      </div>
    </v-card>
    <editor-bind-modal :type="modalType" :title="modalIndex == 0 ? $t('seatEditor.addMultipleSeatModal.title') : $t('seatEditor.editSeatModal.title')" :component="modalComponent[modalIndex]" :showModalProp="showModalProp"/>
  </div>
  <v-dialog
    transition="dialog-top-transition"
    v-model="isLoading"
    width="auto"
    :content-class="type"
  >
    <v-progress-circular model-value="20" indeterminate></v-progress-circular>
  </v-dialog>
</template>

<script>
import { Stage, Layer, Image, Transformer, Group, Text, Rect, Path} from 'konva';
import Konva from 'konva';
import { mapActions } from 'vuex';
import EditorBindModal from './EditorBindModal';
import AddMultipleSeatModalComponent from './AddMultipleSeatModalComponent';
import EditSeatModalComponent from './EditSeatModalComponent';

export default {
  name: 'KonvaSeatEditor',
  components: {
    EditorBindModal,
  },
  props: {
    currentSector: {
      type: Object,
      required: true,
    },
    currentLayer: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      stage: undefined,
      layer: undefined,
      editLayer: undefined,
      appendSeatItems: [
        {
          title: this.$t('seatEditor.newSeat.single'),
          img: 'mdi-sofa-single',
          action: () => {
            this.showModalProp = false;
            this.modalIndex = 0;
            if (this.editLayer.find(`#transformer`).length !== 0) {
              for (const current of this.editLayer.find(`#transformer`)) {
                current.destroy();
                this.editLayer.children.forEach((el) => {
                  if (el.attrs.name === 'Seat') {
                    el.moveTo(this.layer);
                  }
                })
              }
            }
            this.addSeat();
          }
        },
        {
          title: this.$t('seatEditor.newSeat.multiple'),
          img: 'mdi-sofa',
          action: () => {
            this.showModalProp = false;
            this.modalIndex = 0;
            this.modalType = 'multiple-seat-editor';
            this.showModalProp = true;
          }
        },
      ],
      editorSizes: {
        width: undefined,
        height: undefined,
      },
      focusedElement: undefined,
      editSeatProps: undefined,
      modalType: undefined,
      showModalProp: false,
      modalIndex: 0,
      selectionRectangle: undefined,
      selectionAttrs: {
        x1: undefined,
        y1: undefined,
        x2: undefined,
        y2: undefined,
      },
      selectedSeats: [],
      needRefreshEditModal: true,
      currentSectorName: undefined,
      seatLayout: undefined,
      layoutSeats: undefined,
      isDeletingShape: false,
      isLoading: true,
    }
  },
  mounted() {
    this.emitter.on('okButtonClicked', this.handleOkbutton);
    this.setEditorSizes();
    this.stage = new Stage({
      container: this.$refs.container,
      width: this.editorSizes.width,
      height: this.editorSizes.height,
      draggable: true,
      name: 'Stage',
    });

    const payload = {
      sector_id: this.currentSector.id,
      layout_sector_id: this.currentLayer.id,
      title: this.currentSector.name,
    }
    this.createSeatLayoutApi(payload)
      .then((res) => {
        this.getSeatsForLayout();
        this.seatLayout = res;
        if (res.image != null) {
          this.getImage();
        }
        this.getSectorName();
      })

    document.addEventListener('mousedown', (e) => {
      if(e.button === 0) this.stage.draggable(false); 
    });
    document.addEventListener('mouseup', (e) => { 
        if(e.button === 0) this.stage.draggable(true); 
    });

    this.stage.on('wheel', this.zoom);
    this.stage.on('click', this.handleClick);
    this.stage.on('touchstart', this.handleClick);
    this.stage.on('dragstart', () => {
      if (this.stage.draggable()) {
        this.stageDragStart();
      }
    });
    this.stage.on('mousedown', this.handleMouseDown);
    this.stage.on('mouseup', this.handleMouseUp);
    this.stage.on('mousemove', this.handleMouseMove);
    
    this.layer = new Layer({
      listening: false,
    });

    this.editLayer = new Layer ({
      draggable: false,
    })

    this.stage.add(this.layer);
    this.stage.add(this.editLayer);

    this.selectionRectangle = new Rect({
      name: 'Select',
      fill: 'rgba(0,0,255,0.5)',
      visible: false,
    });
    this.editLayer.add(this.selectionRectangle);
  },
  beforeUnmount() {
    this.emitter.off('okButtonClicked', this.handleOkbutton);
  },
  methods: {
    ...mapActions({
      getPartnerSectorsApi: 'productLayout/getPartnerSectors',
      uploadImageToSeatApi: 'productLayout/uploadImageToSeat',
      getImageForSeatApi: 'productLayout/getImageForSeat',
      createSeatLayoutApi: 'productLayout/createSeatLayout',
      // getSeatLayoutApi: 'productLayout/getSeatLayout',
      getSeatsForLayoutApi: 'productLayout/getSeatsForLayout',
      createRelationSeatToLayoutApi: 'productLayout/createRelationSeatToLayout',
      deleteRelationSeatToLayoutApi: 'productLayout/deleteRelationSeatToLayout',
      updateSeatLayoutApi: 'productLayout/updateSeatLayout',
    }),
    stageDragStart() {
      if (this.editLayer.find(`#transformer`).length !== 0) {
        for (const current of this.editLayer.find(`#transformer`)) {
          current.destroy();
        }
      }
    },
    showInfoModal() {
      this.emitter.emit('showBasicModal', {
        title: this.$t('sectorEditor.actionInfoModal.title'),
        description: this.$t('sectorEditor.actionInfoModal.description'),
        okButton: this.$t('sectorEditor.actionInfoModal.button'),
        textAlign: 'text-left'
      })
    },
    handleOkbutton() {
      if (this.editLayer.find(`#transformer`).length !== 0) {
        for (const current of this.editLayer.find(`#transformer`)) {
          current.destroy();
          setTimeout(() => {
            this.editLayer.children.forEach((el) => {
              if (el.attrs.name === 'Seat') {
                el.moveTo(this.layer);
              }
            })
          }, 50);
        }
      }
      if (this.isDeletingShape) {
        if (this.selectedSeats.length != 0) {
          for (const current of this.selectedSeats) {
            const payload = {
              layout_seat_id: this.seatLayout.id,
              seat_id: current.attrs.id,
            }
            this.deleteRelationSeatToLayoutApi(payload)
              .then(() => {
                current.destroy();
              })
              .catch((err) => {
                console.log(err);
              })
          }
          this.saveSeats(false);
        }
        if (this.focusedElement) {
          const payload = {
            layout_seat_id: this.seatLayout.id,
            seat_id: this.focusedElement.attrs.id,
          }
          this.deleteRelationSeatToLayoutApi(payload)
            .then(() => {
              this.focusedElement.destroy();
              this.saveSeats(false);
            })
            .catch((err) => {
              console.log(err);
            })
        }
        this.isDeletingShape = false;
        this.showEditorModal = false;
      }
    },
    getSeatsForLayout() {
      this.getSeatsForLayoutApi(this.currentSector.id)
        .then((res) => {
          this.layoutSeats = res;
        })
        .catch((err) => {
          console.log(err);
        })
    },
    // getSeatLayout(payload) {
    //   this.getSeatLayoutApi(payload)
    //     .then((res) => {
    //       console.log(res);
    //       this.getSeatsForLayout();
    //       this.seatLayout = res;
    //       if (res.image != null) {
    //         this.getImage();
    //       }
    //       this.getSectorName();
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       this.isLoading = false;
    //     })
    // },
    getSectorName() {
      const payload = {
        sector_layout_id: this.currentLayer.id,
      }
      this.getPartnerSectorsApi(payload)
        .then((res) => {
          res.map((item) => {
            if (item.id == this.currentSector.id) {
              this.currentSectorName = item.name;
            }
          })
        })
        .catch((err) => {
          console.log(err);
        })
    },
    loadSeats(viewData) {
      const parsedData = JSON.parse(viewData);
      for (const current of parsedData) {
        this.drawSeat(current);
      }
      this.isLoading = false;
    },
    drawSeat(current) {
      const localeScaleX = this.layer.find(`#image`)[0].attrs.width / current.imageSizes.width;
      const localeScaleY = this.layer.find(`#image`)[0].attrs.height / current.imageSizes.height;
      let seat = new Group({
        id: current.id,
        isLoaded: true,
        name: 'Seat',
        draggable: true,
        x: 0,
        y: 0,
        height: 20,
        width: 15,
        cornerRadius: 0,
        rowIndex: current.row,
        colIndex: current.col,
        number: current.title,
      });
      seat.clearCache();

      const image = new Path({
        data: `M5 0.7271h9.7727s5 0 5 5v3.6364s0 5 -5 5h-9.7727s-5 0 -5 -5v-3.6364s0 -5 5 -5, M2 15.7271h15.7727s2 0 2 2v0.7727s0 2 -2 2h-15.7727s-2 0 -2 -2v-0.7727s0 -2 2 -2`,
        strokeWidth: 1,
        fill: "black",
        stroke: "black",
        name: "Image",
        id: 'image',
        x: 0,
        y: 0,
        height: 20,
        width: 15,
        cornerRadius: 0,
        rowIndex: current.row,
        colIndex: current.col,
        number: current.title,
      });

      var simpleText = new Text({
        width: 20,
        align: "center",
        // eslint-disable-next-line
        y: image.height() / 2 - 6,
        text: current.title,
        // eslint-disable-next-line
        fontSize: 8 - 0.48 * current.title.length,
        fontFamily: "Calibri",
        fontStyle: "bold",
        fill: "white",
        opacity: 0.9,
        perfectDrawEnabled: false,
      });
      seat.add(image);
      seat.add(simpleText);

      let seatPlaceholder = new Rect({
        x: 0,
        y: 0,
        height: 20,
        width: 20,
        fill: "green",
        opacity: 0,
      })
      seat.add(seatPlaceholder);
      image.listening(false);
      simpleText.listening(false);
      seat.absolutePosition({
        x: current.x * localeScaleX,
        y: current.y * localeScaleY,
      })
      seat.scaleX(current.scaleX * localeScaleX);
      seat.scaleY(current.scaleY * localeScaleY);
      seat.rotation(current.rotation);
      this.layer.add(seat);
    },
    throttle(func, delay) {
      let canRun = true;
      return function() {
        if (!canRun) return;
        canRun = false;
        func.apply(this, arguments);
        setTimeout(() => {
          canRun = true;
        }, delay);
      };
    },
    handleMouseMove(e) {
      if (this.mouseDown) {
        const posX = this.stage.getRelativePointerPosition().x;
        const posY = this.stage.getRelativePointerPosition().y;
        if (this.selectionRectangle.visible()) {
          e.evt.preventDefault();
          this.selectionAttrs.x2 = posX;
          this.selectionAttrs.y2 = posY;

          this.selectionRectangle.setAttrs({
            x: Math.min(this.selectionAttrs.x1, this.selectionAttrs.x2),
            y: Math.min(this.selectionAttrs.y1, this.selectionAttrs.y2),
            width: Math.abs(this.selectionAttrs.x2 - this.selectionAttrs.x1),
            height: Math.abs(this.selectionAttrs.y2 - this.selectionAttrs.y1),
          });
        }
      }
    },
    handleMouseDown(e) {
      this.mouseDown = true;
      this.needRefreshEditModal = false;
      if ([2].includes(e.evt.which) && this.editLayer.find(`#transformer`).length !== 0) {
        this.editLayer.find('#transformer')[0].destroy();
        setTimeout(() => {
          this.editLayer.children.forEach((el) => {
            if (el.attrs.name === 'Seat') {
              el.moveTo(this.layer);
            }
          })
        }, 50);
      }
      if ([2,3].includes(e.evt.which)) {
        return
      }
      if (['Image', 'Stage'].includes(e.target.name())) {
        this.selectionAttrs.x1 = this.stage.getRelativePointerPosition().x;
        this.selectionAttrs.y1 = this.stage.getRelativePointerPosition().y;
        this.selectionAttrs.x2 = this.stage.getRelativePointerPosition().x;
        this.selectionAttrs.y2 = this.stage.getRelativePointerPosition().y;
        this.selectionRectangle.zIndex(10000);
        this.selectionRectangle.visible(true);
        this.selectionRectangle.width(0);
        this.selectionRectangle.height(0);
      }
    },
    handleMouseUp(e) {
      this.mouseDown = false;
      if ([2].includes(e.evt.which) && this.layer.find(`#transformer`).length == 0) {
        this.editMultipleSeat(this.selectedSeats);
      }
      if ([2].includes(e.evt.which) && this.focusedElement) {
        this.editSeat(this.focusedElement);
      }
      if ([2,3].includes(e.evt.which)) {
        return
      }
      if (this.selectionRectangle.visible()) {
        e.evt.preventDefault();
        setTimeout(() => {
          this.selectionRectangle.visible(false);
        });

        let shapes = this.stage.find('.Seat');
        let box = this.selectionRectangle.getClientRect();
        let selected = shapes.filter((shape) =>
          Konva.Util.haveIntersection(box, shape.children[2].getClientRect())
        );
        this.editMultipleSeat(selected);
        this.selectionRectangle.visible(true);
        this.selectionRectangle.width(0);
        this.selectionRectangle.height(0);
      }
      if (this.focusedElement && this.selectedSeats.length == 0) {
        this.needRefreshEditModal = true;
      }
    },
    editMultipleSeat(seats) {
      if (this.editLayer.find(`#transformer`).length !== 0) {
        for (const current of this.editLayer.find(`#transformer`)) {
          current.destroy();
          setTimeout(() => {
            if (seats) {
              this.editLayer.children.forEach((el) => {
                if (el.attrs.name === 'Seat') {
                  el.moveTo(this.layer);
                }
              })
            }
          }, 50);
        }
      }
      if (!this.isDrawing) {
        seats.forEach((el) => {
          el.moveTo(this.editLayer);
          el.children[0].listening(false);
          el.children[1].listening(false);
        });
        setTimeout(() => {
          const multyTransformer = new Transformer({
            nodes: seats,
            rotateEnabled: true,
            rotationSnaps: [0, 90, 180, 270],
            id: 'transformer',
            ignoreStroke: true,
          });
          this.multyTransformer = multyTransformer;
          this.editLayer.add(multyTransformer);
        }, 100);
        this.selectedSeats = seats;
        if (this.selectedSeats.length == 1) {
          this.selectedSeats = [];
        }
        if (this.selectedSeats.length) {
          setTimeout(() => {
            this.modalIndex = 1;
            this.modalType = 'sector-editor seat';
            this.showModalProp =  true;      
          }, 100);
        }
      }
    },
    handleClick() {
      // if (event.target.parent && event.target.parent.name() != 'Seat' || event.target.name() == 'Stage') {
      //   if (!event.target.name().includes('_anchor')) {
      //     this.showModalProp = false;
      //     if (this.layer.find('#transformer').length != 0) {
      //       this.layer.find('#transformer')[0].destroy();
      //     }
      //   }
      //   return;
      // }
      this.showModalProp = false;
      if (this.editLayer.find('#transformer').length != 0) {
        this.editLayer.find('#transformer')[0].destroy();
        this.editLayer.children.forEach((el) => {
          setTimeout(() => {
            if (el.attrs.name === 'Seat') {
              el.moveTo(this.layer);
            }  
          }, 50);
        })
      }
      const seats = this.layer.find(`.Seat`);
      let seat;
      const currCurPos = this.stage.getRelativePointerPosition();
      seat = seats.filter((el) => {
        const seatClient = el.children[2].getClientRect({relativeTo: this.stage});
        const minX = seatClient.x;
        const maxX = seatClient.x + seatClient.width;
        const minY = seatClient.y;
        const maxY = seatClient.y + seatClient.height;
        return (
          currCurPos.x > minX &&
          currCurPos.x < maxX &&
          currCurPos.y > minY &&
          currCurPos.y < maxY
        );
      });
      if (seat[0]) {
        setTimeout(() => {
          seat[seat.length - 1].moveTo(this.editLayer);
          this.editSeat(seat[seat.length - 1]);
        }, 50);
      }
    },
    editSeat(item) {
      if (this.editLayer.find(`#transformer`).length !== 0) {
        for (const current of this.editLayer.find(`#transformer`)) {
          current.destroy();
          setTimeout(() => {
            this.editLayer.children.forEach((el) => {
              if (el.attrs.name === 'Seat') {
                el.moveTo(this.layer);
              }
            })
          }, 50);
        }
      }
      const transformer = new Transformer({
        node: item,
        rotateEnabled: true,
        rotationSnaps: [0, 90, 180, 270],
        id: 'transformer',
        ignoreStroke: true,
        perfectDrawEnabled: false,
      });
      // setTimeout(() => {
        this.editLayer.add(transformer);
        this.transformer = transformer;
        this.focusedElement = item;
        this.modalIndex = 1;
        this.modalType = 'sector-editor seat';
        this.showModalProp = true;
      // }, 100);
    },
    addSeat() {
      for (let i = 0; i < this.layoutSeats.length; i++) {
        if (this.layoutSeats[i].used == false || this.layoutSeats[i].used == undefined) {
          let seat = new Group({
            id: this.layoutSeats[i].id,
            name: 'Seat',
            draggable: true,
            x: 0,
            y: 0,
            height: 20,
            width: 15,
            cornerRadius: 0,
            rowIndex: this.layoutSeats[i].row,
            colIndex: this.layoutSeats[i].col,
            number: this.layoutSeats[i].title,
            perfectDrawEnabled: false,
            isLoaded: false,
          });

          const image = new Path({
            data: `M5 0.7271h9.7727s5 0 5 5v3.6364s0 5 -5 5h-9.7727s-5 0 -5 -5v-3.6364s0 -5 5 -5, M2 15.7271h15.7727s2 0 2 2v0.7727s0 2 -2 2h-15.7727s-2 0 -2 -2v-0.7727s0 -2 2 -2`,
            strokeWidth: 1,
            fill: "black",
            stroke: "black",
            name: "Image",
            id: 'image',
            x: 0,
            y: 0,
            height: 20,
            width: 15,
            cornerRadius: 0,
            rowIndex: this.layoutSeats[i].row,
            colIndex: this.layoutSeats[i].col,
            number: this.layoutSeats[i].title,
          });

          var simpleText = new Text({
            width: 20,
            align: "center",
            // eslint-disable-next-line
            y: image.height() / 2 - 6,
            text: this.layoutSeats[i].title,
            // eslint-disable-next-line
            fontSize: 8 - 0.6 * this.layoutSeats[i].title.length,
            fontFamily: "Calibri",
            fontStyle: "bold",
            fill: "white",
            opacity: 0.9,
            perfectDrawEnabled: false,
          });
          simpleText.listening(false);
          image.listening(false);
          seat.add(image);
          seat.add(simpleText);
          let seatPlaceholder = new Rect({
            x: 0,
            y: 0,
            height: 20,
            width: 20,
            fill: "green",
            opacity: 0,
          })
          seat.add(seatPlaceholder);
          seat.absolutePosition({
            x: 100,
            y: 100,
          })
          this.layoutSeats[i].used = true;
          this.layer.add(seat);
        }
      }
    },
    addMultipleSeat(gridAttrs) {
      const startCoordX = gridAttrs.startCoordX;
      const startCoordY = gridAttrs.startCoordY;
      const endCoordX = gridAttrs.endCoordX;
      const endCoordY = gridAttrs.endCoordY;
      const isFromRight = gridAttrs.isFromRight;
      const isRowMode = gridAttrs.isRowMode;
      for (let i = 0; i < this.layoutSeats.length; i++) {
        if ((this.layoutSeats[i].row >= startCoordY && this.layoutSeats[i].row <= endCoordY) &&
        (this.layoutSeats[i].col >= startCoordX && this.layoutSeats[i].col <= endCoordX) &&
        (this.layoutSeats[i].used == false || this.layoutSeats[i].used == undefined)) {
            let seat = new Group({
              id: this.layoutSeats[i].id,
              name: 'Seat',
              draggable: true,
              x: 0,
              y: 0,
              height: 20,
              width: 15,
              cornerRadius: 0,
              rowIndex: this.layoutSeats[i].row,
              colIndex: this.layoutSeats[i].col,
              number: this.layoutSeats[i].title,
              perfectDrawEnabled: false,
              isLoaded: false,
            });

            const image = new Path({
            data: `M5 0.7271h9.7727s5 0 5 5v3.6364s0 5 -5 5h-9.7727s-5 0 -5 -5v-3.6364s0 -5 5 -5, M2 15.7271h15.7727s2 0 2 2v0.7727s0 2 -2 2h-15.7727s-2 0 -2 -2v-0.7727s0 -2 2 -2`,
            strokeWidth: 1,
            fill: "black",
            stroke: "black",
            name: "Image",
            id: 'image',
            x: 0,
            y: 0,
            height: 20,
            width: 15,
            cornerRadius: 0,
            rowIndex: this.layoutSeats[i].row,
            colIndex: this.layoutSeats[i].col,
            number: this.layoutSeats[i].title,
            perfectDrawEnabled: false,
          });

          var simpleText = new Text({
            width: 20,
            align: "center",
            // eslint-disable-next-line
            y: image.height() / 2 - 6,
            text: this.layoutSeats[i].title,
            // eslint-disable-next-line
            fontSize: 8 - 0.6 * this.layoutSeats[i].title.length,
            fontFamily: "Calibri",
            fontStyle: "bold",
            fill: "white",
            opacity: 0.9,
            perfectDrawEnabled: false,
          });
          seat.add(image);
          seat.add(simpleText);
          if (isFromRight) {
            if (isRowMode) {
              seat.absolutePosition({
                y: ((20 + 8) * this.layoutSeats[i].row) + this.editorSizes.width / 3 - 200,
                x: -1 * ((15 + 13) * this.layoutSeats[i].col) + this.editorSizes.height / 3,
              })
            } else {
              seat.absolutePosition({
                x: -1 * ((20 + 8) * this.layoutSeats[i].row) + this.editorSizes.width / 3,
                y: (15 + 13) * this.layoutSeats[i].col + this.editorSizes.height / 3,
              })
            } 
          } else {
            if (isRowMode) {
              seat.absolutePosition({
                y: ((20 + 8) * this.layoutSeats[i].row) + this.editorSizes.width / 3 - 200,
                x: (15 + 13) * this.layoutSeats[i].col + this.editorSizes.height / 3,
              })
            } else {
              seat.absolutePosition({
                x: ((20 + 8) * this.layoutSeats[i].row) + this.editorSizes.width / 3,
                y: ((15 + 13) * this.layoutSeats[i].col) + this.editorSizes.height / 3,
              })
            }
          }
            this.layer.add(seat);
            this.layoutSeats[i].used = true;
          }
        }
    },
    uploadImage() {
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.selectedImage = e.target.files[0];
      const bodyFormData = new FormData();
      if (this.selectedImage) {
        bodyFormData.append("files", this.selectedImage);
      }
      bodyFormData.append("seatId", this.seatLayout.id);
      this.isLoading = true;
      this.uploadImageToSeatApi(bodyFormData)
        .then(() => {
          this.getImage();
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        })
    },
    setEditorSizes() {
      const main = document.getElementById('main-container');
      this.editorSizes.width = main.offsetWidth;
      this.editorSizes.height = main.offsetHeight - 110;
      if (window.innerWidth < 700) {
        this.editorSizes.height = main.offsetHeight - 400;
      }
    },
    getImage() {
      this.getImageForSeatApi(this.seatLayout.id)
        .then((res) => {
          this.setImageBackground(res);
        })
        .catch((err) => {
          console.log(err);
        })
    },
    setImageBackground(imgBase64) {
      const baseImg = new window.Image();
      baseImg.src = `data:image/jpg;base64,${imgBase64}`;
      baseImg.onload = () => {
        this.layer.find('#image')[0]?.destroy();
        const image = new Image({
          image: baseImg,
          x: 0,
          y: 0,
          cornerRadius: 0,
          name: 'Image',
          id: 'image'
        })
        const imagePlaceSizeRatioWidth = this.editorSizes.width / image.width();
        const imagePlaceSizeRatioHeight = this.editorSizes.height / image.height();
        const ratio = imagePlaceSizeRatioHeight < imagePlaceSizeRatioWidth ? imagePlaceSizeRatioHeight : imagePlaceSizeRatioWidth;
        image.height(image.height() * ratio);
        image.width(image.width() * ratio);
        image.listening(false);
        this.layer.add(image);
        if (this.seatLayout.view_data) {
          this.loadSeats(this.seatLayout.view_data);
        }
        this.isLoading = false;
      }
    },
    zoom(e) {
      if (this.editLayer.find(`#transformer`).length !== 0) {
        this.editLayer.find('#transformer')[0].destroy();
      }
      e.evt.preventDefault();
      let scaleBy = 1.2;
      let oldScale = this.stage.scaleX();
      let pointer = this.stage.getRelativePointerPosition();
      let mousePointTo = {
        x: (pointer.x - this.stage.x()) / oldScale,
        y: (pointer.y - this.stage.y()) / oldScale,
      };
      let direction = e.evt.deltaY > 0 ? -1 : 1;
      if (e.evt.ctrlKey) {
        direction = -direction;
      }
      let newScale = direction > 0 ? oldScale * scaleBy : oldScale / scaleBy;
      this.stage.scale({ x: newScale, y: newScale });
      let newPos = {
        x: pointer.x - mousePointTo.x * newScale,
        y: pointer.y - mousePointTo.y * newScale,
      };
      this.stage.position(newPos);
      // if (this.editLayer.find(`#transformer`).length == 0 && this.selectedSeats.length != 0) {
      //   this.editMultipleSeat(this.selectedSeats);
      // }
      // if (this.editLayer.find(`#transformer`).length == 0 && this.focusedElement) {
      //   this.editSeat(this.focusedElement);
      // }
    },
    zoomWithBtn(isIn = false) {
      let scaleBy = 1.2;
      let oldScale = this.stage.scaleX();

      let center = {
        x: this.stage.width() / 2,
        y: this.stage.height() / 2,
      };

      let relatedTo = {
        x: (center.x - this.stage.x()) / oldScale,
        y: (center.y - this.stage.y()) / oldScale,
      };

      let newScale =
        isIn ? oldScale * scaleBy : oldScale / scaleBy;

      this.stage.scale({
        x: newScale,
        y: newScale
      });

      let newPos = {
        x: center.x - relatedTo.x * newScale,
        y: center.y - relatedTo.y * newScale,
      };
      
      this.stage.position(newPos);
      this.stage.batchDraw();
    },
    saveSeat(current) {
      let mappedSeat;
      mappedSeat = {
        id: current.attrs.id,
        x: current.attrs.x,
        y: current.attrs.y,
        scaleX: current.attrs.scaleX,
        scaleY: current.attrs.scaleY,
        rotation: current.attrs.rotation,
        row: current.attrs.rowIndex,
        col: current.attrs.colIndex,
        title: current.attrs.number,
        imageSizes: {
          width: this.layer.find(`#image`)[0].attrs.width,
          height: this.layer.find(`#image`)[0].attrs.height,
        },
      };
      return mappedSeat;
    },
    saveToApi(list) {
      const newList = list;
      const payload = {
        body: {
          view_data: JSON.stringify(newList),
        },
        layoutId: this.seatLayout.id,
      }
      this.updateSeatLayoutApi(payload)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        })
    },
    async saveSeats() {
      const allSeats = this.layer.find('.Seat');
      const allSeatsMapped = [];
      this.isLoading = true;
      if (allSeats.length == 0) {
        this.saveToApi([]);
      }
      for (const current of allSeats) {
        if(!current.attrs.isLoaded) {
          const payload = {
            layout_seat_id: this.seatLayout.id,
            seat_id: current.attrs.id,
          }
          await this.createRelationSeatToLayoutApi(payload)
            .then(() => {
              current.attrs.isLoaded = true;
              allSeatsMapped.push(this.saveSeat(current));
            })
            .catch((err) => {
              console.log(err);
            })
        } else {
          allSeatsMapped.push(this.saveSeat(current));
        }
      }
      this.saveToApi(allSeatsMapped);
      this.isLoading = false;
    },
  },
  computed: {
    modalComponent() {
      return [
        {
          bind: {
            is: AddMultipleSeatModalComponent,
          },
          on: {
            closeModal: () => {
              this.showModalProp = false;
            },
            createGrid: (props) => {
              this.addMultipleSeat(props);
              this.showModalProp = false;
            },
          }
        },
        {
          bind: {
            is: EditSeatModalComponent,
            item: this.focusedElement,
            isMultiple: this.selectedSeats.length != 0,
            needRefresh: this.needRefreshEditModal,
          },
          on: {
            closeModal: () => {
              this.focusedElement = undefined;
              this.selectedSeats = [];
              this.showModalProp = false;
            },
            saveSeat: (itemAttrs) => {
              if (this.selectedSeats.length == 0) {
                this.focusedElement.setAbsolutePosition({
                  x: itemAttrs.xCord,
                  y: itemAttrs.yCord
                });
                this.focusedElement.scaleX(itemAttrs.width / this.focusedElement.attrs.width);
                this.focusedElement.scaleY(itemAttrs.height / this.focusedElement.attrs.height );
                this.focusedElement.rotation(itemAttrs.rotation);
                this.focusedElement.children[1].text(itemAttrs.number);
              }
              this.showModalProp = false;
              this.saveSeats();
            },
            removeSeat: () => {
              this.isDeletingShape = true;
              this.emitter.emit('showBasicModal', {
                title: this.$t('sectorEditor.removeShapeConfirmationModal.title'),
                description: this.$t('sectorEditor.removeShapeConfirmationModal.description'),
                cancelButton: this.$t('sectorEditor.removeShapeConfirmationModal.cancelButton'),
                okButton: this.$t('sectorEditor.removeShapeConfirmationModal.okButton'),
              })
            },
          }
        }
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
#main-container {
  height: calc(100% - 20px);
  .title {
    margin-top: 16px;
    font-size: 22px;
    font-weight: 550;
  }
  .actions {
    display: flex;
    align-items: center;
    margin: 16px 0;
    .append-menu {
      margin-right: 12px;
    }
    .upload-image {
      .upload-btn {
        color: white;
      }
      .hidden-uploader {
        display: none !important;
      }
    }
    .info-btn {
      margin-left: auto;
    }
    .save-seats {
      margin-left: auto;
    }
  }
  .editor-section {
    position: relative;
    .konva-container {
      &.currently-drawing {
        &:hover {
          cursor: crosshair;
        }
      }
    }
    .btn-section {
      position: absolute;
      bottom: 18px;
      right: 18px;
      width: 110px;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>